import React from "react";
import heartGif from "../../assets/red-heart-bumping.gif";
import headingImg1 from "../../assets/headingImg1.svg";
import headingImg2 from "../../assets/HeadingImg4.svg";
import headingImg3 from "../../assets/HeadingImg7.svg";
import headingImg4 from "../../assets/headingImg8.svg";
import settlingImg from "../../assets/SETTLING.jpg";
import playImg from "../../assets/playgroup.jpg";
import nurseryImg from "../../assets/nursery.jpg";
import preNurImg from "../../assets/preNur.jpg";
import CustomHeading from "../custom/CustomHeading";
import CustomContent from "../custom/CustomContent";
import PinkHeartGif from "../../assets/pinkHeart.svg";
import plusStarImg from "../../assets/plusStar.svg";
import mobileNurseryImg from "../../assets/mobileNursery.jpg";
import mobileSettlingImg from "../../assets/mobileSettling.jpg";
import mobilePlayImg from "../../assets/mobilePlayGroup.jpg";
import mobilePreNurImg from "../../assets/mobilePreNur.jpg";
import momAndIImg from "../../assets/MOM&I.jpg";
import mobileMomAndIImg from "../../assets/mobileMOM&I.jpg"

const Stages = () => {
  return (
    <div className="flex bg-[#E0FAFF] mt-[40px] py-[50px] sm:py-[100px] px-[4%] flex-col gap-[6rem] sm:gap-[5rem]">
      {/*1st div*/}
      <div className="flex flex-col sm:flex-row gap-[1rem] lg:gap-[3rem] justify-between items-center relative">
        <img
          src={PinkHeartGif}
          alt="settling Img "
          className="w-[80px] h-[80px] absolute bottom-[10%] right-[5%]"
        />
        <div className="lg:w-[50%] text-justify relative flex flex-col gap-4">
          <CustomHeading
            text={"Mom & I"}
            textSize={"50px"}
            smTextSize="32px"
            textColor={"#D31C4F"}
            leading={"60px"}
          />
          <CustomContent
            textColor="#111010"
            textSize={"23px"}
            leading="36px"
            tracking="tracking-tight"
            textAlign={window.innerWidth < 450 ? "left" : "justify"}
            text={
              `The 'Mom & I’ programme believes in the transformative power of love and togetherness in early childhood. We harness <b>‘early bonds</b> and <b>lasting love’</b>. India’s first-of-its-kind, this three-month program empowers mothers to nurture their toddler’s holistic development, strengthening lifelong bonds.`
            }
          />
          <img
            src={window.innerWidth < 450 ? mobileMomAndIImg:momAndIImg}
            alt="settling Img "
            className="sm:w-full z-10 rounded-2xl w-full h-[280px] sm:h-[300px] lg:h-[370px]"
          />
          <img
            src={plusStarImg}
            alt="settling Img "
            className="w-[80px] h-[80px] z-0 absolute bottom-[-18%] left-[5%]"
          />
        </div>
        <div className="w-[50%] ">
          <img
            src={headingImg1}
            alt="img-1"
            className="lg:block hidden lg:w-[377px] h-[304px] absolute top-[20%] left-[60%]"
          />
        </div>
      </div>
      {/* 2nd div */}
      <div className="flex flex-col sm:flex-row-reverse gap-[1rem] lg:gap-[3rem] justify-between items-center relative">
        <div className="lg:w-[50%] text-justify  flex flex-col gap-4">
          <CustomHeading
            text={"Settling"}
            textSize={"50px"}
            textColor={"#D31C4F"}
            smTextSize="32px"
            leading={"60px"}
          />
          <CustomContent
            textColor="#111010"
            text={
              "To make the child feel at ease, a dedicated settling zone has been made for the child stepping out of the home for the first time. Interesting activities are organised that keep the environment upbeat for children."
            }
            textSize={"23px"}
            leading="36px"
            tracking="tracking-tight"
            textAlign={window.innerWidth < 450 ? "left" : "justify"}
          />
          <img
            src={window.innerWidth < 450 ? mobileSettlingImg : settlingImg}
            alt="playGroup-img "
            className="rounded-2xl w-full h-[280px] sm:h-[300px] lg:h-[370px]"
          />
        </div>
        <div className="w-[50%] relative">
          <img
            src={headingImg2}
            alt="img-1"
            className="lg:block hidden ml-[100px] w-[398px] h-[502px]"
          />
          <img
            src={PinkHeartGif}
            alt="settling Img "
            className="w-[80px] h-[80px] skew-x-[10deg] absolute top-[10%] left-[5%]"
          />
        </div>
      </div>
      {/* 3rd div */}
      <div className="flex flex-col sm:flex-row gap-[1rem] lg:gap-[3rem] justify-between items-center relative">
        <div className="lg:w-[63%] text-justify  flex flex-col gap-4">
          <CustomHeading
            text={"Play Group Till 2.5 Years"}
            textSize={"50px"}
            textColor={"#D31C4F"}
            smTextSize="32px"
            leading={"60px"}
          />
          <CustomContent
            textColor="#111010"
            textSize={"23px"}
            leading="36px"
            textAlign={window.innerWidth < 450 ? "left" : "justify"}
            text={
              "With the playgroup, tiny tots take the first step into the world of growth and learning. Here, the child is made familiar with a more structured day. In addition to this, a dynamic learning system is implemented to emphasise on sensory learning, active exploration and introduction of new themes."
            }
            tracking="tracking-tight"
          />
          <img
            src={window.innerWidth < 450 ? mobilePlayImg : playImg}
            alt="prenur-img "
            className="rounded-2xl w-full h-[280px] sm:h-[300px] lg:h-[370px]"
          />
        </div>
        <div className="w-[50%] relative">
          <img
            src={plusStarImg}
            alt="settling Img "
            className="w-[100px] h-[100px] absolute bottom-[-100px] sm:bottom-[-20%] right-[25%]"
          />
          <img
            src={headingImg3}
            alt="img-1"
            className="lg:block hidden ml-[20%] rotate-6 w-[426px] h-[331px]"
          />
        </div>
      </div>
      {/* 4th div */}
      <div className="flex flex-col sm:flex-row-reverse gap-[1rem] lg:gap-[3rem] justify-between items-center relative">
        <div className="lg:w-[50%] text-justify relative flex flex-col gap-4">
          <img
            src={PinkHeartGif}
            alt="settling Img "
            className="w-[80px] h-[80px] absolute top-[-10%] right-[8%]"
          />
          <CustomHeading
            text={"Pre-Nursery till 2 to 3 years"}
            textSize={"50px"}
            textColor={"#D31C4F"}
            smTextSize="32px"
            leading={"60px"}
          />
          <CustomContent
            textColor="#111010"
            textSize={"23px"}
            leading="36px"
            textAlign={window.innerWidth < 450 ? "left" : "justify"}
            width={window.innerWidth < 950 ? "w-[100%]" : "w-[90%]"}
            text={
              "Pre-Nursery is the programme that takes the child a step ahead in their educational journey. Efforts are made to build the reasoning and problem-solving skills of the students."
            }
            tracking="tracking-tight"
          />
          <img
            src={window.innerWidth < 450 ? mobilePreNurImg : preNurImg}
            alt="nur-img "
            className="rounded-2xl w-full h-[280px] sm:h-[300px] lg:h-[370px]"
          />
        </div>
        <div className="w-[50%]">
          <img
            src={headingImg4}
            alt="img-1"
            className="absolute lg:block hidden top-0 w-[434px] h-[526px]"
          />
        </div>
      </div>
      {/* 5th div */}
      <div className="flex flex-col sm:flex-row gap-[1rem] lg:gap-[3rem] justify-between items-center relative">
        <div className="lg:w-[50%] text-justify  flex flex-col gap-4">
          <CustomHeading
            text={"Nursery 3 to 4 years"}
            textSize={"50px"}
            textColor={"#D31C4F"}
            leading={"60px"}
          />
          <CustomContent
            textColor="#111010"
            textSize={"23px"}
            leading="36px"
            textAlign={window.innerWidth < 450 ? "left" : "justify"}
            text={
              "The aim of the school in grade nursery is to make the students real thinkers, who can think critically and handle some situations on their own. They are also taught how to work well within a group through listening, sharing and cooperation."
            }
            tracking="tracking-tight"
          />
          <img
            src={window.innerWidth < 450 ? mobileNurseryImg : nurseryImg}
            alt="prenur-img "
            className="rounded-2xl w-full h-[280px] sm:h-[300px] lg:h-[370px]"
          />
        </div>
        <div className="w-[50%] relative">
          <img
            src={plusStarImg}
            alt="settling Img "
            className="w-[100px] h-[100px] absolute bottom-[-65px] sm:bottom-[-0%] right-[25%]"
          />
          <img
            src={headingImg3}
            alt="img-1"
            className="lg:block hidden ml-[20%] rotate-6 w-[426px] h-[331px]"
          />
        </div>
      </div>
    </div>
  );
};

export default Stages;
